import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "security-consultation-sydney";
const serviceId = 3;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Security Consultation Sydney | Ozy Wide Group",
    description:
      "Practical security audits, risk reviews and protection planning for Sydney homes, businesses and active sites.",
    keywords:
      "security consultation Sydney, security risk assessment, security audit, safety consultation, property security review",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Security Consultation",
    description:
      "Practical security audits, risk reviews and protection planning for Sydney homes, businesses and active sites.",
    points: createServicePoints(
      "Current risks and gaps reviewed",
      "Systems and staffing options compared",
      "Action plan prioritised by risk",
    ),
    images: createImageItems(images, "Security Consultation Sydney"),
    content,
  };
